import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showClear", "allowClear", "renderExtraFooter", "addon"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import TimePicker from './TimePicker';
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;

var TimePickerWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePickerWrapper, _React$Component);

  var _super = _createSuper(TimePickerWrapper);

  function TimePickerWrapper() {
    var _this;

    _classCallCheck(this, TimePickerWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleTimeChange", function (time) {
      var _this$props = _this.props,
          format = _this$props.format,
          onChange = _this$props.onChange;
      var timeString = '';

      if (time !== null && typeof time.format == 'function') {
        timeString = time.format(format);
      }

      onChange && onChange(time, timeString);
    });

    return _this;
  }

  _createClass(TimePickerWrapper, [{
    key: "render",
    value: function render() {
      isShouldUpdate("TimePicker", this.props);

      var _this$props2 = this.props,
          showClear = _this$props2.showClear,
          allowClear = _this$props2.allowClear,
          renderExtraFooter = _this$props2.renderExtraFooter,
          addon = _this$props2.addon,
          others = _objectWithoutProperties(_this$props2, _excluded);

      var extral = {
        renderExtraFooter: addon || renderExtraFooter,
        allowClear: showClear !== undefined ? showClear : allowClear,
        onChange: this.handleTimeChange
      };
      return /*#__PURE__*/React.createElement(TimePicker, _extends({}, others, extral));
    }
  }]);

  return TimePickerWrapper;
}(React.Component);

export default TimePickerWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timepicker/src/index.js